// research-filter.js – FINAL VERSION MIT TOGGLE
import mixitup from 'mixitup';

$(document).ready(function() {
    if (!$('.mixit--filter').length) return;

    // Check grid type for animation config
    var isResearchGrid = $('.research--grid').length > 0;
    var isEventsGrid = $('.events--grid').length > 0;
    
    var mixerConfig = {
        selectors: {
            control: '.mixitup-control'
        },
        load: {
            filter: 'all' // Start: alles anzeigen
        },
        controls: {
            toggleLogic: 'and' // Wichtig für Toggle!
        },
        callbacks: {
            onMixStart: function() {
                $('.mix').removeClass(function(i, className) {
                    return (className.match(/\bsearch-match-\d+/g) || []).join(' ');
                });
            },
            onMixEnd: function(state) {
                // Only show/hide no results message for research--grid
                if ($('.research--grid').length > 0) {
                    // Check if there are visible items
                    var visibleCount = state.show.length;
                    var $noResults = $('.research--no-results');
                    var $grid = $('.research--grid');
                    
                    if (visibleCount === 0) {
                        $grid.hide();
                        $noResults.show();
                    } else {
                        $grid.show();
                        $noResults.hide();
                    }
                }
            }
        }
    };

    if (isResearchGrid) {
        mixerConfig.animation = {
            enable: false,
            duration: 0,
            effects: ""
        };
    } else if (isEventsGrid) {
        mixerConfig.animation = {
            // duration: 300,
            // effects: "fade",
            // nudge: false,
            // animateResizeContainer: false,
            // easing: 'ease-in-out'
            enable: false,
            duration: 0,
            effects: ""
        };
    } else {
        mixerConfig.animation = {
            animateResizeTargets: true,
            duration: 550,
            nudge: true,
            reverseOut: false,
            effects: "fade scale(0.01) translateZ(-100px)"
        };
    }

    $('.mixit--filter.events--grid').each(function () {
        var $grid = $(this);
        var descending = $grid.attr('data-event-order') === 'desc';
        var items = $grid.children('.mix').get();

        items.sort(function (a, b) {
            var startA = $(a).attr('data-start') || '';
            var startB = $(b).attr('data-start') || '';
            if (startA < startB) return descending ? 1 : -1;
            if (startA > startB) return descending ? -1 : 1;
            return 0;
        });

        $.each(items, function (_, item) {
            $grid.append(item);
        });
    });

    var mixer = mixitup(".mixit--filter", mixerConfig);

    // ========== NUR AUF RESEARCH-SEITE: SUCHFUNKTION ==========
    if (!isResearchGrid) return;

    var $searchInput = $('#research-search-input');
    var $searchClear = $('#research-search-clear');
    var searchTimeout = null;
    var activeFilters = ['all']; // Start: alles sichtbar

    // Show/hide clear button based on input value
    function toggleClearButton() {
        if ($searchInput.val().length > 0) {
            $searchClear.show();
        } else {
            $searchClear.hide();
        }
    }

    // Clear search input and reset search
    $searchClear.on('click', function(e) {
        e.preventDefault();
        $searchInput.val('');
        $searchClear.hide();
        
        // Reset search to show all items based on active filters
        if (activeFilters.length === 0 || activeFilters[0] === 'all') {
            mixer.filter('all');
        } else {
            mixer.filter(activeFilters.join(','));
        }
    });

    // Toggle clear button on input
    $searchInput.on('input', function() {
        toggleClearButton();
    });

    // --- Beim Klick auf Button: Toggle + Update activeFilters ---
    $(document).on('click', '.post-button', function(e) {
        e.preventDefault();
        var $btn = $(this);
        var filter = $btn.data('filter'); // z.B. ".cat-12"

        // Toggle: Ist der Filter schon aktiv?
        if ($btn.hasClass('active')) {
            $btn.removeClass('active');
            activeFilters = activeFilters.filter(f => f !== filter);
        } else {
            $btn.addClass('active');
            activeFilters.push(filter);
        }

        // Wenn nichts mehr aktiv → zeige alle
        if (activeFilters.length === 0 || (activeFilters.length === 1 && activeFilters[0] === 'all')) {
            mixer.filter('all');
            activeFilters = ['all'];
        } else {
            // Entferne 'all' falls andere Filter aktiv
            activeFilters = activeFilters.filter(f => f !== 'all');
            mixer.filter(activeFilters.join(','));
        }
    });

    // --- Suche mit Delay ---
    $searchInput.on('keyup search', function() {
        toggleClearButton();
        clearTimeout(searchTimeout);

        searchTimeout = setTimeout(function() {
            var query = $searchInput.val().toLowerCase().trim();

            if (query === '') {
                // Zeige aktuelle Filter (oder alle)
                if (activeFilters.length === 0 || activeFilters[0] === 'all') {
                    mixer.filter('all');
                } else {
                    mixer.filter(activeFilters.join(','));
                }
                return;
            }

            var selectors = [];
            $('.mixit--filter .mix').each(function() {
                var $item = $(this);
                var searchText = ($item.data('search') || '').toString().toLowerCase();

                if (searchText.indexOf(query) !== -1) {
                    var matchesCategory = activeFilters.length === 0 || 
                                        activeFilters.includes('all') || 
                                        $item.is(activeFilters.join(','));

                    if (matchesCategory) {
                        var index = $item.index();
                        var tempClass = 'search-match-' + index;
                        $item.addClass(tempClass);
                        selectors.push('.' + tempClass);
                    }
                }
            });

            if (selectors.length > 0) {
                mixer.filter(selectors.join(', '));
            } else {
                mixer.filter('none');
            }
        }, 300);
    });
});